import type { AgreementType } from '../types/product';

export type AgreementKey = AgreementType | 'none';

export const AGREEMENT_ORDER: AgreementKey[] = ['DA', 'CPA', 'LOI', 'Gentleman', 'none'];

export const AGREEMENT_PILL_CLASSES: Record<AgreementKey, string> = {
  DA: 'bg-emerald-100 text-emerald-800 border-emerald-200 dark:bg-emerald-900/30 dark:text-emerald-300 dark:border-emerald-800/60',
  CPA: 'bg-sky-100 text-sky-800 border-sky-200 dark:bg-sky-900/30 dark:text-sky-300 dark:border-sky-800/60',
  Gentleman: 'bg-slate-100 text-slate-700 border-slate-200 dark:bg-slate-900/30 dark:text-slate-300 dark:border-slate-800/60',
  LOI: 'bg-amber-100 text-amber-800 border-amber-200 dark:bg-amber-900/30 dark:text-amber-300 dark:border-amber-800/60',
  none: 'bg-rose-50 text-rose-700 border-rose-200 dark:bg-rose-900/20 dark:text-rose-300 dark:border-rose-800/60',
};

export const AGREEMENT_DOT_CLASSES: Record<AgreementKey, string> = {
  DA: 'bg-emerald-500',
  CPA: 'bg-sky-500',
  Gentleman: 'bg-slate-400',
  LOI: 'bg-amber-500',
  none: 'bg-rose-400',
};
